import { createSlice } from '@reduxjs/toolkit';

export const imagesSlice = createSlice({
  name: 'images',
  initialState: {
    images: [],
  },
  reducers: {
    addImages: (state, action) => {
      state.images = action.payload
    },
  },
});

export const { addImages } = imagesSlice.actions;

export const selectImages = state => state.images.images;

export default imagesSlice.reducer;
